module.exports = __webpack_public_path__ + "img/dd.2dfda573.png";